<template>
  <b-message
    v-if="quoteExportFailed.isOpen"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-label="Modal"
    aria-modal
    v-bind="$attrs"
    class="quote_export_failed_alert"
    @close="closeModal"
  >
    <div class="quote_export_failed_alert__container">
      <header class="w-100 mb-5">
        <h1 class="is-relative">
          {{ quoteExportFailed.title }}
        </h1>
      </header>
      <main
        class="w-100 is-flex is-flex-direction-column is-align-items-start mb-2"
      >
        <p class="has-text-left" style="font-size: 0.8rem">
          This items have issues:
        </p>

        <div class="quote_export_failed_alert__container--list w-100">
          <ul class="mt-2">
            <li
              v-for="item in quoteExportFailed.items"
              :key="item.id"
              class="text-left"
            >
              <a :href="item.link" target="_blank" class="has-text-link">
                {{ item.message }}
              </a>
            </li>
          </ul>
        </div>

        <p v-if="0" class="mt-4" style="font-size: 0.8rem; text-align: left">
          <strong>
            We recommend you to update all services to the latest version, you
            can do it by clicking the button below.
          </strong>
          <span>
            If the issue persists, please contact support(support@itereo.travel)
          </span>
        </p>

        <div class="is-flex is-justify-content-end mt-4" style="width: 100%">
          <BaseButton
            v-if="0"
            class="mt-4"
            action="primary"
            size="small"
            @click="onUpdateAllServices(quoteServices)"
          >
            <p slot="text">Update All Sales</p>
          </BaseButton>
        </div>
      </main>
    </div>
  </b-message>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "QuoteExportFailedAlert",
  props: {
    updateService: {
      type: Function,
      default: () => {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      quoteExportFailed: "itinerary/getQuoteExportFailed",
      quoteServices: "itinerary/getServicesItinerary",
    }),
  },
  methods: {
    async onUpdateAllServices(payload) {
      this.setLoading(true);

      await this.updateService(payload);

      this.$store.dispatch("itinerary/reloadQuoteServices");

      this.closeModal();

      this.setLoading(false);
    },
    closeModal() {
      this.$store.dispatch("itinerary/closeQuoteExportFailedAlert");
    },
  },
};
</script>
<style>
.quote_export_failed_alert__container {
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40rem;
  height: auto;
  border-radius: 1rem;
  padding: 1.5rem;
  text-align: center;
  font-family: Poppins, sans-serif;
  position: fixed;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  top: 2rem;
  left: 50%;
  transform: translateX(-50%);
}
.quote_export_failed_alert__container > header > h1 {
  color: #1e1e1e;
  font-size: 1.25rem;
  font-weight: 700;
  text-align: left;
}

.quote_export_failed_alert__container--list {
  max-height: 10rem;
  overflow-y: auto;
}
.quote_export_failed_alert__container ul {
  margin-left: 1.5rem;
  list-style: disc;
}

.quote_export_failed_alert__container li {
  list-style: disc;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  text-align: left;
}

.quote_export_failed_alert {
  z-index: 999;
  position: fixed;
}

.quote_export_failed_alert .modal-background {
  display: none;
}
</style>
